import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 62C57FBE-8457-442F-AD8D-510CF2080FFF
 * name greater-than-or-equal
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/greater-than-or-equal.svg
 * tags
 * - Math 
 */
export const GreaterThanOrEqualIcon = createSvgIcon(<><path d="M6.5,2.27L20,10.14L6.5,18L5.5,16.27L16.03,10.14L5.5,4L6.5,2.27M20,20V22H5V20H20Z" /></>, 'GreaterThanOrEqualIcon');
export default GreaterThanOrEqualIcon